export const motivo = [
    {
        CODMOTIVO: 1,
        DESCRICAO: 'Não especificado',
    },
    {
        CODMOTIVO: 2,
        DESCRICAO: 'Não codificado',
    },
    {
        CODMOTIVO: 3,
        DESCRICAO: 'Quadro sincopal',
    },
    {
        CODMOTIVO: 4,
        DESCRICAO: 'Hipofluxo cerebral',
    },
    {
        CODMOTIVO: 5,
        DESCRICAO: 'Bradicardia',
    },
    {
        CODMOTIVO: 6,
        DESCRICAO: 'Taquicardia',
    },
    {
        CODMOTIVO: 7,
        DESCRICAO: 'Profilático',
    },
    {
        CODMOTIVO: 8,
        DESCRICAO: 'Insuficiência Cardíaca',
    },
    {
        CODMOTIVO: 9,
        DESCRICAO: 'Doença do Nó Sinusal',
    },
    {
        CODMOTIVO: 10,
        DESCRICAO: 'BAV 2:1',
    },
    {
        CODMOTIVO: 11,
        DESCRICAO: 'BAV 2o Grau Tipo II',
    },
    {
        CODMOTIVO: 12,
        DESCRICAO: 'BAVT',
    },
    {
        CODMOTIVO: 13,
        DESCRICAO: 'BAV Avançado',
    },
];

export const etiologia = [
    {
        CODETIOLOGIA: 1,
        DESCRICAO: 'Não especificada',
    },
    {
        CODETIOLOGIA: 2,
        DESCRICAO: 'Causa desconhecida',
    },
    {
        CODETIOLOGIA: 3,
        DESCRICAO: 'Doença de Chagas',
    },
    {
        CODETIOLOGIA: 4,
        DESCRICAO: 'Miocardioesclerose',
    },
    {
        CODETIOLOGIA: 5,
        DESCRICAO: 'Insuficiência Coronariana',
    },
    {
        CODETIOLOGIA: 6,
        DESCRICAO: 'Infarto do Miocárdio',
    },
    {
        CODETIOLOGIA: 7,
        DESCRICAO: 'Sequela pós cirúrgica',
    },
    {
        CODETIOLOGIA: 8,
        DESCRICAO: 'Cardiopatia Congênita',
    },
    {
        CODETIOLOGIA: 9,
        DESCRICAO: 'Miocardiopatia Dilatada',
    },
    {
        CODETIOLOGIA: 10,
        DESCRICAO: 'Miocardite',
    },
    {
        CODETIOLOGIA: 11,
        DESCRICAO: 'Valvopatia',
    },
    {
        CODETIOLOGIA: 12,
        DESCRICAO: 'Hipersensibilidade do Seio Carotídeo',
    },
    {
        CODETIOLOGIA: 13,
        DESCRICAO: 'Pós ablação de via anômala',
    },
    {
        CODETIOLOGIA: 14,
        DESCRICAO: 'Uso de drogas bradicardizantes',
    },
];

export const fabricante = [
    {
        CODFABRICANTE: 1,
        FABRICANTE: 'Medtronic',
    },
    {
        CODFABRICANTE: 2,
        FABRICANTE: 'Telectronics',
    },
    {
        CODFABRICANTE: 3,
        FABRICANTE: 'Biotronik',
    },
    {
        CODFABRICANTE: 4,
        FABRICANTE: 'CPI',
    },
    {
        CODFABRICANTE: 5,
        FABRICANTE: 'Biomedics',
    },
    {
        CODFABRICANTE: 6,
        FABRICANTE: 'Vigomed',
    },
    {
        CODFABRICANTE: 7,
        FABRICANTE: 'Sorin',
    },
    {
        CODFABRICANTE: 8,
        FABRICANTE: 'Brascor',
    },
    {
        CODFABRICANTE: 9,
        FABRICANTE: 'Pacesetter',
    },
    {
        CODFABRICANTE: 10,
        FABRICANTE: 'Oscor Medical',
    },
    {
        CODFABRICANTE: 11,
        FABRICANTE: 'BEA',
    },
    {
        CODFABRICANTE: 12,
        FABRICANTE: 'Vitatron',
    },
    {
        CODFABRICANTE: 13,
        FABRICANTE: 'St Jude',
    },
    {
        CODFABRICANTE: 14,
        FABRICANTE: 'Boston',
    },
    {
        CODFABRICANTE: 15,
        FABRICANTE: 'ABBOTT',
    },
];

export const modelo = [
    {
        CODMODELO: 1,
        MODELO: 'Prevail 8086',
    },
    {
        CODMODELO: 2,
        MODELO: 'Prodigy 7862',
    },
    {
        CODMODELO: 3,
        MODELO: 'Prevail 8085',
    },
    {
        CODMODELO: 4,
        MODELO: 'Capsurefix 4068',
    },
    {
        CODMODELO: 5,
        MODELO: 'Capsurefix 5068',
    },
    {
        CODMODELO: 6,
        MODELO: 'Capsure 5024',
    },
    {
        CODMODELO: 7,
        MODELO: 'Prodigy SR 8161',
    },
    {
        CODMODELO: 8,
        MODELO: 'Sigma DR 303',
    },
    {
        CODMODELO: 9,
        MODELO: 'Capsure 5034',
    },
    {
        CODMODELO: 10,
        MODELO: 'Prodigy SR 8160',
    },
    {
        CODMODELO: 11,
        MODELO: 'Thera SR 8962 i',
    },
    {
        CODMODELO: 12,
        MODELO: 'PS 60 UP',
    },
    {
        CODMODELO: 13,
        MODELO: 'YP 53 BP',
    },
    {
        CODMODELO: 14,
        MODELO: 'Prodigy SR 8162',
    },
    {
        CODMODELO: 15,
        MODELO: 'Sigma SR 303',
    },
    {
        CODMODELO: 16,
        MODELO: '5026-58',
    },
    {
        CODMODELO: 17,
        MODELO: 'TIR 60 BP',
    },
    {
        CODMODELO: 18,
        MODELO: 'TIJ 53 BP',
    },
    {
        CODMODELO: 19,
        MODELO: '4012-58',
    },
    {
        CODMODELO: 20,
        MODELO: 'TIR 60 UP',
    },
    {
        CODMODELO: 21,
        MODELO: 'YP 60 BP',
    },
    {
        CODMODELO: 22,
        MODELO: 'Sigma SR 306',
    },
    {
        CODMODELO: 23,
        MODELO: '4011-58',
    },
    {
        CODMODELO: 24,
        MODELO: '4003-58',
    },
    {
        CODMODELO: 25,
        MODELO: '030-400',
    },
    {
        CODMODELO: 26,
        MODELO: 'NP 60 BP',
    },
    {
        CODMODELO: 27,
        MODELO: 'PE 60/4 DN',
    },
    {
        CODMODELO: 28,
        MODELO: 'Capsure novus 5054',
    },
    {
        CODMODELO: 29,
        MODELO: 'Tempo DR 2102',
    },
    {
        CODMODELO: 30,
        MODELO: '1148 T',
    },
    {
        CODMODELO: 31,
        MODELO: '033-301',
    },
    {
        CODMODELO: 32,
        MODELO: '033-462',
    },
    {
        CODMODELO: 33,
        MODELO: '033-448',
    },
    {
        CODMODELO: 34,
        MODELO: 'DNP 60 UP',
    },
    {
        CODMODELO: 35,
        MODELO: '4512 13',
    },
    {
        CODMODELO: 36,
        MODELO: '1346 T',
    },
    {
        CODMODELO: 37,
        MODELO: '6972-58',
    },
    {
        CODMODELO: 38,
        MODELO: 'DJP 60 UP',
    },
    {
        CODMODELO: 39,
        MODELO: 'Sigma DR 306',
    },
    {
        CODMODELO: 40,
        MODELO: 'KY 611',
    },
    {
        CODMODELO: 41,
        MODELO: '6957 J 53',
    },
    {
        CODMODELO: 42,
        MODELO: '4004-58',
    },
    {
        CODMODELO: 43,
        MODELO: '4503-53',
    },
    {
        CODMODELO: 44,
        MODELO: '6957-58',
    },
    {
        CODMODELO: 45,
        MODELO: '5071-53 epi / uni',
    },
    {
        CODMODELO: 46,
        MODELO: 'PS  53  UP',
    },
    {
        CODMODELO: 47,
        MODELO: 'TIR 53 BP',
    },
    {
        CODMODELO: 48,
        MODELO: '4261- 59',
    },
    {
        CODMODELO: 49,
        MODELO: 'DFH 60 A',
    },
    {
        CODMODELO: 50,
        MODELO: '5025-58',
    },
    {
        CODMODELO: 51,
        MODELO: 'Kappa KDR 403',
    },
    {
        CODMODELO: 52,
        MODELO: '033-484 F',
    },
    {
        CODMODELO: 53,
        MODELO: '5058',
    },
    {
        CODMODELO: 54,
        MODELO: 'Thera DR 7962 i',
    },
    {
        CODMODELO: 55,
        MODELO: '033-572',
    },
    {
        CODMODELO: 56,
        MODELO: '4067',
    },
    {
        CODMODELO: 57,
        MODELO: '4003-58',
    },
    {
        CODMODELO: 58,
        MODELO: 'QT 611 T',
    },
    {
        CODMODELO: 59,
        MODELO: 'PY 67',
    },
    {
        CODMODELO: 60,
        MODELO: 'Kappa KSR 403',
    },
    {
        CODMODELO: 61,
        MODELO: 'S 100 uni',
    },
    {
        CODMODELO: 62,
        MODELO: '5064-58 bifurcado 5m',
    },
    {
        CODMODELO: 63,
        MODELO: 'Capsure Novus 5054',
    },
    {
        CODMODELO: 64,
        MODELO: 'Capsurefix 5076-58',
    },
    {
        CODMODELO: 65,
        MODELO: 'Maxim 033-301',
    },
    {
        CODMODELO: 66,
        MODELO: '493-03',
    },
    {
        CODMODELO: 67,
        MODELO: 'PEB 60/4K10',
    },
    {
        CODMODELO: 68,
        MODELO: '6962-58',
    },
    {
        CODMODELO: 69,
        MODELO: '4058M',
    },
    {
        CODMODELO: 70,
        MODELO: 'Kappa KDR 901',
    },
    {
        CODMODELO: 71,
        MODELO: 'Capsurefix 4568 - 53',
    },
    {
        CODMODELO: 73,
        MODELO: 'Capsure VDD-2 5038S-',
    },
    {
        CODMODELO: 74,
        MODELO: 'SL 60/13 BP',
    },
    {
        CODMODELO: 75,
        MODELO: 'Kappa KSR 901',
    },
    {
        CODMODELO: 76,
        MODELO: '1188T',
    },
    {
        CODMODELO: 77,
        MODELO: '5984BLP',
    },
    {
        CODMODELO: 78,
        MODELO: 'Kappa KDR 903',
    },
    {
        CODMODELO: 79,
        MODELO: 'Kappa KSR 903',
    },
    {
        CODMODELO: 80,
        MODELO: 'Kappa KSR 906',
    },
    {
        CODMODELO: 81,
        MODELO: '4269',
    },
    {
        CODMODELO: 82,
        MODELO: 'S-80',
    },
    {
        CODMODELO: 84,
        MODELO: 'Actfix ICF09',
    },
    {
        CODMODELO: 85,
        MODELO: 'C20SR',
    },
    {
        CODMODELO: 86,
        MODELO: 'ICM09B',
    },
    {
        CODMODELO: 87,
        MODELO: 'T70DR',
    },
    {
        CODMODELO: 88,
        MODELO: '4069',
    },
    {
        CODMODELO: 89,
        MODELO: 'Sentra',
    },
    {
        CODMODELO: 90,
        MODELO: '1388T',
    },
    {
        CODMODELO: 91,
        MODELO: 'Enpulse E2SR03',
    },
];

export const hospital = [
    {
        value: 'Santa Casa de Misericórdia de Marília',
        label: 'Santa Casa de Misericórdia de Marília',
    },
    {
        value: 'Santa Casa de Misericórdia de Tupã',
        label: 'Santa Casa de Misericórdia de Tupã',
    },
    {
        value: 'UNIMAR',
        label: 'UNIMAR',
    },
    {
        value: 'FAMEMA',
        label: 'FAMEMA',
    },
    {
        value: 'HCOR SAO PAULO',
        label: 'HCOR SAO PAULO',
    },
    {
        value: 'IMC SAO JOSE RIO PRETO',
        label: 'IMC SAO JOSE RIO PRETO',
    },
    {
        value: 'PRESIDENTE PRUDENTE',
        label: 'PRESIDENTE PRUDENTE',
    },
    {
        value: 'BAURU',
        label: 'BAURU',
    },
    {
        value: 'BOTUCATU',
        label: 'BOTUCATU',
    },
    {
        value: 'SALTO',
        label: 'SALTO',
    },
    {
        value: 'HC MARILIA',
        label: 'HC MARILIA',
    },
    {
        value: 'OURINHOS',
        label: 'OURINHOS',
    },
    {
        value: 'LINS',
        label: 'LINS',
    },
];